import React, { useEffect } from 'react'
import { Label, Image, Button } from 'semantic-ui-react'
import './Home.scss'
import chromo from '../../assets/cromo.png' 
import firefox from '../../assets/firefox.png' 
import edge from '../../assets/explorador.png' 
import ilus_inicio from '../../assets/ilus-inicio.svg'
import { withRouter } from 'react-router'

const Home = props => {

    const goToSignIn = () => {
        props.history.push('/signin')
    }

    const goToGuide = () => {
        props.history.push('/guide')
    }

    return (
        <div className='home'>
            <div className='home_left'>
                <Image src={ilus_inicio} />
            </div>
            <div className='home_right'>
                <h1>Bienvenido a Shield</h1>
                <Label>Empoderate hoy en el mundo digital con el diverso uso de tus datos</Label>

                <div className='icons_image'>
                    <Image src={chromo} />
                    <Image src={firefox} />
                    <Image src={edge} />
                </div>

                <Button onClick={goToGuide}>Empezar</Button>

                <div className='intro'>
                    <span onClick={goToSignIn}>Saltar intro</span>

                    <div className='carousel'>
                        <div className='carousel_circle' style={{ backgroundColor: '#68bbe3' }} />
                        <div className='carousel_circle' />
                        <div className='carousel_circle' />
                        <div className='carousel_circle' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Home)
